module.exports = __webpack_public_path__ + "static/media/fragrance.c675e6ee.png";